import { getAccountScopeUserConfiguration } from 'mini-common-utils/lib/utils/getAccountScopeUserConfiguration';
import { updateUserConfigurationService } from 'owa-service/lib/utils/updateUserConfigurationService';

export const VIEW_STATE_CONFIGURATION = 'OWA.ViewStateConfiguration';
/**
 * Updates search history in the user configuration.
 */
export default function updateSearchHistoryUserConfig(): void {
    const accountScopedUserConfiguration = getAccountScopeUserConfiguration();

    if (accountScopedUserConfiguration && accountScopedUserConfiguration.ViewStateConfiguration) {
        const { SearchHistory } = accountScopedUserConfiguration.ViewStateConfiguration;

        updateUserConfigurationService(
            [
                {
                    key: 'SearchHistory',
                    valuetype: 'StringArray',
                    value: SearchHistory,
                    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
                     * See aka.ms/mini-lint-errors
                     *	> Unexpected any. Specify a different type. */
                } as any,
            ],
            VIEW_STATE_CONFIGURATION
        );
    }
}
